import { Component, ErrorHandler, Inject, Input, DOCUMENT, ChangeDetectionStrategy } from '@angular/core'
import { AloitaTunnistautuminenJaAnnaUrlResponse, AloitaTunnistautuminenMaksutJaAnnaUrlRequest, InGroupeAuthMethod, PaymentDueType } from '@lemon/core-firebase/model/tunnistaminen'
import { FirebaseLemonaid } from 'app/_angular/service/firebase-lemonaid.service'
import { KayttajaService } from 'app/_angular/service/kayttaja.service'
import { TunnistautuminenService } from 'app/_angular/service/tunnistautuminen.service'
import { LadataanService } from 'app/_jaettu-angular/service/ladataan.service'
import { environment } from 'environments/environment'
import { TunnistautuminenNetsPankitComponent } from './pankit.component'

export interface MaksutVahvistusData {
  maksut: string[]
  dueType: PaymentDueType
  paymentConfigId: string
}

@Component({
  selector: '[tunnistautuminen-nets-maksujen-vahvistus-pankit]',
  templateUrl: './pankit.component.html',
  styleUrls: ['./pankit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TunnistautuminenNetsMaksujenVahvistusComponent extends TunnistautuminenNetsPankitComponent {
  @Input() maksutVahvistusData: MaksutVahvistusData

  constructor(
    @Inject(DOCUMENT) private __document: Document,
    private __kirjautunutKayttajaService: KayttajaService,
    private __ladataanService: LadataanService,
    private __errorHandler: ErrorHandler,
    private __tunnistautuminenService: TunnistautuminenService,
    protected __firebaseLemonaid: FirebaseLemonaid,
  ) {
    super(__document, __kirjautunutKayttajaService, __ladataanService, __errorHandler, __tunnistautuminenService, __firebaseLemonaid)
  }

  protected override async _aloitaTunnistautuminenJaAnnaUrl(authMethod: InGroupeAuthMethod): Promise<AloitaTunnistautuminenJaAnnaUrlResponse> {
    const request: AloitaTunnistautuminenMaksutJaAnnaUrlRequest = {
      action: this.actionAfterSuccess,
      authMethod,
      kieli: this.kieli || 'fi',
      env: this._tunnistautuminenService.getNetsEnvironment(environment.environment),
      maksut: this.maksutVahvistusData.maksut,
      dueType: this.maksutVahvistusData.dueType,
      paymentConfigId: this.maksutVahvistusData.paymentConfigId,
    }
    return this._firebaseLemonaid.functionsCall<AloitaTunnistautuminenMaksutJaAnnaUrlRequest, AloitaTunnistautuminenJaAnnaUrlResponse>('tunnistautuminenNetsAloitaMaksutJaAnnaUrl', request)
  }
}
